<div class="sfoot">
  <!-- The profile row: the avatar, who you are, and the way out. -->
  <!--
    Named by what it shows, then what it does ("Jane Doe Pro plan, account menu"): an aria-label of
    its own would replace the visible name a speech-input user reads off the screen (WCAG 2.5.3).
    The panel is a dialog, not a menu, so it is announced as one, and it is only referenced while open.
  -->
  <button
    #overlayTrigger="cdkOverlayOrigin"
    aria-haspopup="dialog"
    cdkOverlayOrigin
    class="sfoot__profile"
    type="button"
    [attr.aria-controls]="profileOverlay.isOpen() ? panelId : null"
    [attr.aria-expanded]="profileOverlay.isOpen()"
    (click)="profileOverlay.toggle()"
  >
    @if (isUserLoading()) {
      <at-skeleton class="sfoot__avatar" />
    } @else {
      <span aria-hidden="true" class="sfoot__avatar">{{ initials() }}</span>
    }

    <span class="sfoot__who">
      <span class="sfoot__name">{{ username() }}</span>
      <!--
        The plan, not the email. The email is already one click away in the menu this row opens, and
        the operator knows their own address — what they cannot see anywhere else at a glance is
        which plan they are working under.
      -->
      @if (tier(); as t) {
        <span class="sfoot__plan-name">{{ t }} plan</span>
      }
    </span>

    <span class="cdk-visually-hidden">, account menu</span>

    <at-icon aria-hidden="true" class="sfoot__chevron">unfold_more</at-icon>
  </button>

  <at-overlay
    #profileOverlay
    panelClass="user-menu-panel"
    scrollStrategy="close"
    [ariaLabelledBy]="headingId"
    [trigger]="overlayTrigger"
  >
    <app-user-profile-overlay
      [email]="email()"
      [headingId]="headingId"
      [id]="panelId"
      [isUserLoading]="isUserLoading()"
      [username]="username()"
      (close)="profileOverlay.close()"
      (logout)="onLogout()"
    />
  </at-overlay>
</div>
